<div class="contenitore">
    <h1>Partner e Enti Affiliati</h1>
    <p>
        La nostra associazione collabora con enti e aziende per promuovere progetti e iniziative legate alla
        crittografia e alla sicurezza informatica.
        Di seguito, troverete l'elenco dei nostri partner e affiliati ufficiali.
    </p>

    <h2>Enti Affiliati</h2>
    <ul>
        <li><a href="https://www.acn.gov.it/portale/home">ACN</a></li>
    </ul>

    <h2>Partner</h2>
    <ul>
        <li><a href="https://www.bvtech.com/">BV TECH S.P.A.</a></li>
        <li><a href="https://datakrypto.com/">DataKrypto S.R.L.</a></li>
        <li><a href="https://www.e4company.com/">E4 Computer Engineering S.P.A.</a></li>
        <li><a href="https://forkbomb.solutions/">FORKBOMB B.V.</a></li>
        <li><a href="https://www.qticompany.com/">QTI S.R.L.</a></li>
        <li><a href="https://www.randompower.eu/">Random Power S.R.L.</a></li>
        <li><a href="https://www.thinkquantum.com/">ThinkQuantum S.R.L.</a></li>
        <li><a href="https://www.bancomat.it">Bancomat S.P.A.</a></li>
    </ul>

    <h2>Sponsor</h2>
    <ul>
       <li><a href="http://www.deloitte.com/">Deloitte Consulting S.R.L.</a></li>
    </ul>

    <h2>Regolamento affiliazioni e partnership</h2>
    <p>
        L'<b>affiliazione</b> è riservata agli enti che condividono i nostri obiettivi e operano nel
        campo della ricerca o sviluppo in crittografia e sicurezza. La <b>partnership</b> è un accordo strategico con
        aziende che offrono tecnologie, supporto o contributi per
        iniziative dell'associazione.
        <br>
        Leggi il <a [routerLink]="['/associazione/regolamento']">regolamento completo</a>.
    </p>
</div>